
import {FC} from "react";

import React from 'react';

import RectificationForm from "../../forms/claim-handling-forms/rectification-form";

interface Interface{
    partSource: any;
    requestId: any;
    mode?: "View" | "Add new";
    onClose?: () => void;
}

const RectificationScreen: FC<Interface> = (props:any) => {

    

    return (
            
                <RectificationForm
                    requestId={props.requestId}
                    partSource={props.partSource}
                    mode={props.mode}
                />
            
    );
}
export default RectificationScreen;
